const INSERT_EMOJI_MODAL = "insertEmojiModal";
const INSERT_EMOJI_MODAL_LIST_ITEM = "emojiListItem";
export {
  INSERT_EMOJI_MODAL,
  INSERT_EMOJI_MODAL_LIST_ITEM
};
//# sourceMappingURL=dataHooks.js.map
